import { primitiveColorTokens } from '@cellula/react-theme-patient';

export function BrandedIllustrationDoor() {
	return (
		<svg viewBox='0 0 400 256' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				stroke='none'
				d='M131 52C131 47.5817 134.582 44 139 44H261C265.418 44 269 47.5817 269 52V220C269 224.418 265.418 228 261 228H139C134.582 228 131 224.418 131 220V52Z'
				fill={primitiveColorTokens.primary['300']}
			/>
			<path
				stroke='none'
				d='M131 40C131 35.5817 134.582 32 139 32H261C265.418 32 269 35.5817 269 40V216C269 220.418 265.418 224 261 224H139C134.582 224 131 220.418 131 216V40Z'
				fill={primitiveColorTokens.primary['600']}
			/>
			<path
				stroke='none'
				d='M139 44C139 41.7909 140.791 40 143 40H241C243.209 40 245 41.7909 245 44V212C245 214.209 243.209 216 241 216H143C140.791 216 139 214.209 139 212V44Z'
				fill={primitiveColorTokens.primary['900']}
			/>
			<path
				stroke='none'
				d='M157 36.8338C157 34.3246 159.284 32.435 161.748 32.9045L237.748 47.3807C239.635 47.74 241 49.3895 241 51.31V212.69C241 214.611 239.635 216.26 237.748 216.619L161.748 231.096C159.284 231.565 157 229.675 157 227.166V36.8338Z'
				fill={primitiveColorTokens.primary['600']}
			/>
			<path
				stroke='none'
				d='M161 28.6909C161 26.2296 163.202 24.3523 165.632 24.7411L257.632 39.4611C259.572 39.7716 261 41.4457 261 43.4109V212.589C261 214.554 259.572 216.228 257.632 216.539L165.632 231.259C163.202 231.648 161 229.77 161 227.309V28.6909Z'
				fill={primitiveColorTokens.primary['500']}
			/>
			<path
				stroke='none'
				d='M187.917 128C187.441 130.838 184.973 133 182 133C178.686 133 176 130.314 176 127C176 123.686 178.686 121 182 121H194.5C196.433 121 198 122.567 198 124.5C198 126.433 196.433 128 194.5 128H187.917Z'
				fill={primitiveColorTokens.primary['600']}
			/>
			<path
				stroke='none'
				d='M187.917 126C187.441 128.838 184.973 131 182 131C178.686 131 176 128.314 176 125C176 121.686 178.686 119 182 119H194.5C196.433 119 198 120.567 198 122.5C198 124.433 196.433 126 194.5 126H187.917Z'
				fill={primitiveColorTokens.primary['800']}
			/>
		</svg>
	);
}
